import api  from './base'


export const createTemplate = async (data,token) => {
	const res=await api.post('/missionTemplate',data,{
		headers: {
			Authorization: `Bearer `+token
		  },
	})
	return res.data
}

export const  getTemplateForMission=async (missionId,token)=>{
    const res = await api.get(`/missionTemplate/${missionId}/for-mission`,{
		headers: {
			  Authorization: `Bearer `+token
			},
   })
   return res.data
}
export const getTemplatesForUser=async(token)=>{
	const res = await api.get(`/missionTemplate`,{
		headers: {
			  Authorization: `Bearer `+token
			},
   })
   return res.data
}
export const deleteTemplate = async (templateId, token) => {
	const res = await api.delete(`/missionTemplate/${templateId}`, {
	  headers: {
		Authorization: `Bearer ${token}`
	  },
	});
	return res.data;
  };

  export const updateTemplate = async (templateId, data, token) => {
	const res = await api.put(`/missionTemplate/${templateId}`, data, {
	  headers: {
		Authorization: `Bearer ${token}`
	  },
	})
	return res.data
  }
  